import {
    type RouteLocationNormalized,
    type Router,
    createRouter,
    createWebHistory,
} from 'vue-router'
import { routes } from './routes'

export const router: Router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 }
    },
})

const TITLE_SUFFIX = ' - ХАБЕР, hublegal.ru'
const DEFAULT_TITLE = 'ООО ПКО ХАБЕР'

// You can add nav guards here
router.beforeEach((to: RouteLocationNormalized) => {
    document.title = to.meta.title ? (to.meta.title as string) + TITLE_SUFFIX : DEFAULT_TITLE

    return true
})
